
import { defineComponent, PropType } from 'vue'
import { iOlapCrossNavigationParameter } from '../Olap'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dropdown from 'primevue/dropdown'
import olapCrossNavigationDefinitionDialogDescriptor from './OlapCrossNavigationDefinitionDialogDescriptor.json'

export default defineComponent({
    name: 'olap-cross-navigation-step-one',
    components: { Column, DataTable, Dropdown },
    props: { propParameters: { type: Array as PropType<iOlapCrossNavigationParameter[]> }, addNewParameterVisible: { type: Boolean }, propSelectedParameter: { type: Object as PropType<iOlapCrossNavigationParameter | null> } },
    emits: ['parameterSelected', 'deleteParameter'],
    data() {
        return {
            olapCrossNavigationDefinitionDialogDescriptor,
            parameters: [] as iOlapCrossNavigationParameter[],
            selectedParameter: {} as iOlapCrossNavigationParameter
        }
    },
    watch: {
        propParameters() {
            this.loadParameters()
        },
        propSelectedParameter() {
            this.loadSelectedParameter()
        }
    },
    created() {
        this.loadParameters()
        this.loadSelectedParameter()
    },
    methods: {
        loadParameters() {
            this.parameters = this.propParameters as iOlapCrossNavigationParameter[]
        },
        loadSelectedParameter() {
            this.selectedParameter = this.propSelectedParameter as iOlapCrossNavigationParameter
        },
        deleteParameterConfirm(parameter: iOlapCrossNavigationParameter) {
            this.$confirm.require({
                message: this.$t('common.toast.deleteMessage'),
                header: this.$t('common.toast.deleteConfirmTitle'),
                icon: 'pi pi-exclamation-triangle',
                accept: async () => this.$emit('deleteParameter', parameter)
            })
        }
    }
})
